var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgVideo = function SvgVideo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.661 17.567h7.007c1.313 0 2.078-.745 2.078-2.057V9.16c0-1.313-.718-2.058-2.03-2.058H6.66c-1.265 0-2.078.745-2.078 2.057v6.35c0 1.313.766 2.058 2.078 2.058Zm9.885-3.329 2.338 1.99c.225.198.471.314.71.314.472 0 .787-.342.787-.855V8.982c0-.512-.315-.854-.786-.854-.24 0-.486.123-.711.314l-2.338 1.983v3.814Z"
  })));
};
export default SvgVideo;